import React from 'react';
import { css } from '@emotion/react';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

const TopGradientBorder = (props: { className?: string }) => {
  const { className } = props;
  const styles = css`
    &.gradient-line {
      position: sticky;
      height: ${quarterSpacing}px;
      background: linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
      top: 0;
    }
  `;

  return (
    <div className={`gradient-line ${className}`} css={styles} />
  );
};

export default TopGradientBorder;
